import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { Filings } from '../../services/Filings';
import { FILEABLE_STATUSES } from '../../../../services/constant/constant';

class FilingStatesGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSecurityType: ''
        };
        this.columnFormat = [
            { orderable: false, targets: '_all' },
            {
                targets: [0],
                orderable: false,
                className: 'select-checkbox',
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('min-width', '20px');
                }
            },
            {
                targets: [1],
                render: function(data, type, full) {
                    return data + ' (' + full.code + ')';
                }
            },
            {
                targets: [2],
                className: 'text-right',
                render: function(data, type, full) {
                    return (
                        '$' +
                        data.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                    );
                }
            },
            {
                targets: [3],
                className: 'text-center',
                render: (data, type, full) => {
                    let filingStatusName = Filings.getFilingStatusName(data);
                    let isSalesReport = full.isSalesReport ? ' (Sales)' : '';
                    return filingStatusName + isSalesReport;
                }
            },
            {
                targets: [4],
                visible: false
            },
            {
                targets: [-1],
                width: '8%',
                className: 'text-center',
                render: (data, type, full) => {
                    if (FILEABLE_STATUSES.includes(data.stateFilingStatus)) {
                        return '<span class="label label-default" style="cursor: pointer; font-size: 90%">File</span>';
                    } else {
                        return null;
                    }
                },
                createdCell: (td, cellData, rowData, row, col) => {
                    let stateData = cellData;
                    if (
                        FILEABLE_STATUSES.includes(stateData.stateFilingStatus)
                    ) {
                        $(td).click(cellData => {
                            props.handleButtonClick(stateData);
                        });
                    }
                }
            }
        ];
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({ selectedSecurityType: nextProps.selectedSecurityType });
    }

    render() {
        let { dataList, updateSelected } = this.props;
        return (
            <DataTable
                columns={[
                    {
                        title: '<span class="glyphicon glyphicon-ok" />',
                        data: null,
                        defaultContent: ''
                    },
                    {
                        title: 'State',
                        data: 'name'
                    },
                    {
                        title: 'Minimum Filing Fee',
                        data: 'minimumFee'
                    },
                    {
                        title: 'Pending Status Description',
                        data: 'stateFilingStatus'
                    },
                    {
                        title: 'Type',
                        data: 'fundFilingType'
                    },
                    {
                        title: 'File',
                        data: null
                    }
                ]}
                id="quickFilingStatesGrid"
                data={dataList}
                columnFormat={this.columnFormat}
                sortable
                checkBoxSelection={true}
                onSelectedItems={updateSelected}
                order={[['1', 'asc']]}
                rowFormat={(row, data, dataIndex) => {
                    if (!FILEABLE_STATUSES.includes(data.stateFilingStatus)) {
                        $(row).addClass('disabled');
                        $(row.children[0]).removeClass('select-checkbox');
                    }
                }}
            />
        );
    }
}

FilingStatesGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    handleButtonClick: PropTypes.func,
    selectedSecurityType: PropTypes.number,
    updateSelected: PropTypes.func
};

FilingStatesGrid.defaultProps = {
    updateSelected: () => {}
};

export default FilingStatesGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/QuickFilingRequest/QuickFilingStatesGrid.js